import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import User from "@mapmycustomers/shared/types/User";
import { Button } from "@mapmycustomers/ui";

import RoundButton from "@app/component/RoundButton";
import ButtonType from "@app/enum/ButtonType";

import messages from "../messages";

import styles from "./Footer.module.scss";

interface Props {
  allowEmpty?: boolean;
  cancelText?: string;
  className?: string;
  confirmText?: string;
  onApply?: () => void;
  onCancel?: () => void;
  onDeselectAll?: () => void;
  onSelectAll?: () => void;
  selectedUserIds: User["id"][];
  users: User[];
}

const Footer: React.FC<Props> = ({
  allowEmpty,
  cancelText,
  className,
  confirmText,
  onApply,
  onCancel,
  onDeselectAll,
  onSelectAll,
  selectedUserIds,
  users,
}) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.selectionInfo}>
        {intl.formatMessage(messages.selectionInfo, {
          count: selectedUserIds.length,
          total: users.length,
        })}
        {selectedUserIds.length > 0 && (
          <RoundButton
            bordered={false}
            className={styles.toggleSelectionButton}
            onClick={onDeselectAll}
            size="small"
            type={ButtonType.SECONDARY}
          >
            {intl.formatMessage(messages.deselectAll)}
          </RoundButton>
        )}
        {selectedUserIds.length < users.length && (
          <RoundButton
            bordered={false}
            className={styles.toggleSelectionButton}
            onClick={onSelectAll}
            size="small"
            type={ButtonType.PRIMARY}
          >
            {intl.formatMessage(messages.selectAll)}
          </RoundButton>
        )}
      </div>
      <div className={styles.buttons}>
        <Button onClick={onCancel}>{cancelText ?? intl.formatMessage(messages.cancel)}</Button>
        <Button disabled={!selectedUserIds.length && !allowEmpty} onClick={onApply} type="primary">
          {confirmText ?? intl.formatMessage(messages.apply)}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
